import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-585939ed"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "text-center mt-4" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'AlertModal',
    props: {
        status: String,
        text: String
    },
    setup: function (__props) {
        var props = __props;
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (props.text == null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(_ctx.$props.status + ' text-center')
                    }, _toDisplayString(_ctx.$t(_ctx.$props.status)), 3))
                    : _createCommentVNode("", true),
                (props.text != null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(_ctx.$props.status + ' text-center')
                    }, _toDisplayString(_ctx.$t(_ctx.$props.text)), 3))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('closeAlert')); }),
                        type: "button",
                        class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                    }, _toDisplayString(_ctx.$t("OK")), 1)
                ])
            ], 64));
        };
    }
});
